import React from 'react';
import { KharonLogo } from '../components/Logo';
import { 
    LockIcon, 
    SparklesIcon, 
    ChevronRightIcon, 
    ArrowLeftIcon,
    ExclamationCircleIcon
} from '../components/icons';
import { useStore } from '../store/useStore';

export const SubscriptionRequiredScreen: React.FC = () => {
    const { logout } = useStore();

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-6 relative overflow-hidden">
            {/* Background Decorations */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20 dark:opacity-10">
                <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary-300 rounded-full blur-[120px] animate-pulse-slow"></div>
                <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-primary-100 rounded-full blur-[150px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
            </div>

            <div className="relative w-full max-w-2xl animate-fade-in-up">
                <div className="bg-white dark:bg-slate-900 rounded-[40px] shadow-luxury border border-slate-100 dark:border-slate-800 p-12 overflow-hidden relative">
                    {/* Top Accent */}
                    <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-primary-400 to-primary-600"></div>
                    
                    <header className="text-center mb-12">
                        <KharonLogo className="h-10 mx-auto text-slate-900 dark:text-white mb-10" />
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 mb-6">
                            <ExclamationCircleIcon className="w-4 h-4" />
                            <span className="text-[10px] font-black uppercase tracking-widest">Acceso Restringido</span>
                        </div>
                        <h1 className="text-4xl font-serif font-bold text-slate-900 dark:text-white tracking-tight">
                            Tu cuenta requiere de un<br/>
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-400">Plan de Uso Activo.</span>
                        </h1>
                        <p className="text-slate-500 dark:text-slate-400 mt-4 max-w-md mx-auto">
                            Estás a un paso de revolucionar la gestión de tu funeraria. Por favor, selecciona un plan para activar todas las herramientas.
                        </p>
                    </header>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                        <div className="p-6 rounded-3xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700 hover:border-primary-500/50 transition-all cursor-pointer group">
                             <div className="flex justify-between items-start mb-4">
                                <div className="p-2 bg-white dark:bg-slate-900 rounded-xl shadow-sm"><SparklesIcon className="w-5 h-5 text-primary-500" /></div>
                                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Recomendado</span>
                             </div>
                             <h3 className="text-lg font-bold text-slate-900 dark:text-white">Independent</h3>
                             <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Perfecto para negocios familiares.</p>
                             <div className="mt-6 flex items-baseline gap-1">
                                <span className="text-2xl font-black text-slate-900 dark:text-white">189€</span>
                                <span className="text-[10px] font-bold text-slate-400">/ mes</span>
                             </div>
                        </div>

                        <div className="p-6 rounded-3xl bg-slate-900 border border-slate-800 hover:ring-2 hover:ring-primary-500 transition-all cursor-pointer">
                             <div className="flex justify-between items-start mb-4">
                                <div className="p-2 bg-slate-800 rounded-xl shadow-sm"><LockIcon className="w-5 h-5 text-primary-400" /></div>
                             </div>
                             <h3 className="text-lg font-bold text-white">Enterprise</h3>
                             <p className="text-xs text-slate-400 mt-1">Escalabilidad para grupos funerarios.</p>
                             <div className="mt-6 flex items-baseline gap-1 text-white">
                                <span className="text-2xl font-black">319€</span>
                                <span className="text-[10px] font-bold text-slate-500">/ mes</span>
                             </div>
                        </div>
                    </div>

                    <div className="flex flex-col items-center gap-6">
                        <button 
                            className="w-full py-5 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-black rounded-2xl shadow-luxury hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-3"
                        >
                            <span>Contactar con Ventas</span>
                            <ChevronRightIcon className="w-5 h-5" />
                        </button>
                        
                        <button 
                            onClick={() => logout()}
                            className="flex items-center gap-2 text-xs font-black text-slate-400 uppercase tracking-[0.2em] hover:text-red-500 transition-colors"
                        >
                            <ArrowLeftIcon className="w-4 h-4" />
                            Cerrar Sesión
                        </button>
                    </div>
                </div>
                
                <p className="text-center mt-8 text-[10px] font-black text-slate-400 dark:text-slate-600 uppercase tracking-[0.3em]">
                    KHARON CLOUD ECOSYSTEM &bull; 2026
                </p>
            </div>
        </div>
    );
};
